import { render, staticRenderFns } from "./makePayment.vue?vue&type=template&id=ce1afb14"
import script from "./makePayment.vue?vue&type=script&lang=js"
export * from "./makePayment.vue?vue&type=script&lang=js"
import style0 from "./makePayment.vue?vue&type=style&index=0&id=ce1afb14&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports